var map = {
	"./TestDataArea_2_Multiple_Layered.html": 8050,
	"./TestDataArea_4_Multiple_Stacked.html": 1829,
	"./TestDataBar_1_Simple.html": 8535,
	"./TestDataBar_2Y.html": 4222,
	"./TestDataBar_4_GradientColor.html": 6284,
	"./TestDataBar_5_PosNegColor.html": 5619,
	"./TestDataBar_6_Transparancy.html": 5588,
	"./TestDataBar_FontFun.html": 653,
	"./TestDataBar_MultiBar_SideBySide.html": 7560,
	"./TestDataBar_MultiBar_Stacked.html": 1605,
	"./TestDataBubble_1_guns.html": 2673,
	"./TestDataBubble_2_series.html": 6002,
	"./TestDataGrids_3_alternateGridFillX.html": 1379,
	"./TestDataGrids_4_alternateGridFillY.html": 3345,
	"./TestDataGrids_5_Gradiant.html": 9173,
	"./TestDataLog_1.html": 3854,
	"./TestDataPieBubble.html": 7936,
	"./TestDataPie_Multi.html": 4982,
	"./TestDataPie_SimplePie.html": 4574,
	"./TestDataXY_Boxplot.html": 385,
	"./TestDataXY_CandlePlot.html": 4098,
	"./TestDataXY_LineExamples.html": 4874,
	"./TestDataXY_Math.html": 4191,
	"./TestDataXY_Polynomals.html": 6475,
	"./TestDataXY_Scatter.html": 1050,
	"./TestDataXY_Simple.html": 2766,
	"./TestDataXY_Simple_Series.html": 33,
	"./TestDataXY_SineCurve.html": 3309,
	"./TestStackedChart2.html": 5909,
	"./TestStackedChart3.html": 8942,
	"./screenshots.html": 4813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8057;